import React, { useState, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Upload() {
  const [uploading, setUploading] = useState(false);
  const [results, setResults] = useState([]);
  const [errors, setErrors] = useState([]);
  const [dragOver, setDragOver] = useState(false);
  const inputRef = useRef(null);
  const navigate = useNavigate();

  const handleFiles = useCallback(async (files) => {
    if (!files.length) return;
    setUploading(true);
    setErrors([]);
    const newResults = [];
    const newErrors = [];
    if (files.length === 1) {
      const fd = new FormData();
      fd.append('file', files[0]);
      try {
        const r = await fetch('/api/documents/upload', { method: 'POST', body: fd });
        if (!r.ok) throw new Error(await r.text());
        newResults.push(await r.json());
      } catch (e) { newErrors.push({ filename: files[0].name, error: e.message }); }
    } else {
      const fd = new FormData();
      Array.from(files).forEach(f => fd.append('files', f));
      try {
        const r = await fetch('/api/documents/bulk-upload', { method: 'POST', body: fd });
        if (!r.ok) throw new Error(await r.text());
        const d = await r.json();
        newResults.push(...(d.results || []));
        if (d.error_details) newErrors.push(...d.error_details);
      } catch (e) { newErrors.push({ filename: 'batch', error: e.message }); }
    }
    setResults(prev => [...prev, ...newResults]);
    setErrors(prev => [...prev, ...newErrors]);
    setUploading(false);
  }, []);

  const onDrop = useCallback((e) => { e.preventDefault(); setDragOver(false); handleFiles(e.dataTransfer.files); }, [handleFiles]);

  return (
    <div style={{ padding: 'var(--gap-lg)', maxWidth: 700 }}>
      <h2 style={{ color: 'var(--text-primary)', marginBottom: 'var(--gap-lg)', fontSize: 'var(--font-size-xl)', fontWeight: 600 }}>Upload</h2>
      <div
        onDragOver={e => { e.preventDefault(); setDragOver(true); }}
        onDragLeave={() => setDragOver(false)}
        onDrop={onDrop}
        onClick={() => inputRef.current?.click()}
        style={{ border: `2px dashed ${dragOver ? '#bb9af7' : 'var(--border)'}`, borderRadius: 'var(--border-radius-lg)', padding: 48, textAlign: 'center', cursor: 'pointer', background: dragOver ? 'rgba(187,154,247,0.05)' : 'var(--bg-secondary)', transition: 'var(--transition-base)' }}
      >
        <div style={{ fontSize: 48, marginBottom: 12 }}>{'\uD83D\uDCE4'}</div>
        <div style={{ color: 'var(--text-primary)', fontWeight: 500, marginBottom: 4 }}>Dateien hierher ziehen</div>
        <div style={{ color: 'var(--text-muted)', fontSize: 'var(--font-size-sm)' }}>oder klicken zum Auswaehlen</div>
        <input ref={inputRef} type="file" multiple hidden onChange={e => handleFiles(e.target.files)} />
      </div>
      {uploading && <div style={{ color: '#bb9af7', marginTop: 16, textAlign: 'center' }}>Uploading...</div>}
      {errors.map((e, i) => (
        <div key={i} style={{ background: 'rgba(247,118,142,0.1)', border: '1px solid rgba(247,118,142,0.3)', borderRadius: 'var(--border-radius)', padding: 12, marginTop: 12, color: '#f7768e', fontSize: 'var(--font-size-sm)' }}>
          {e.filename}: {e.error}
        </div>
      ))}
      {results.length > 0 && (
        <div style={{ marginTop: 'var(--gap-lg)' }}>
          <h3 style={{ color: 'var(--text-primary)', marginBottom: 8, fontSize: 'var(--font-size-base)' }}>Hochgeladen</h3>
          {results.map(r => (
            <div key={r.id} onClick={() => navigate(`/library/${r.id}`)} style={{ background: 'var(--bg-secondary)', border: '1px solid var(--border)', borderRadius: 'var(--border-radius)', padding: 12, marginBottom: 8, cursor: 'pointer', color: 'var(--text-primary)', fontSize: 'var(--font-size-sm)' }}>
              {r.filename} — {r.status}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
